import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSkipped = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("circle", {
			opacity: .2,
			cx: 12,
			cy: 12,
			r: 12,
			fill: "#FF3B30"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8.11108 8.11108L15.8889 15.8889",
			stroke: "#FF3B30",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.8889 8.11108L8.11109 15.8889",
			stroke: "#FF3B30",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgSkipped);
export default ForwardRef;
